export const DEFAULT_PASSWORD_POLICY = {
  minLength: 8,
  specialChars: 1,
  numbers: 1,
  regex: /^(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{8,}).*$/,
};